// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3o77y","active":"downloadDropdown_active__5uL1B"};